var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelenium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "11.8491816%",
    cy: "93.5996601%",
    fx: "11.8491816%",
    fy: "93.5996601%",
    r: "80.4871395%",
    gradientTransform: "translate(0.118492,0.935997),scale(1.000000,0.979374),translate(-0.118492,-0.935997)",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b2b2b",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "31.7474526%",
    cy: "-15.4811849%",
    fx: "31.7474526%",
    fy: "-15.4811849%",
    r: "110.00354%",
    gradientTransform: "translate(0.317475,-0.154812),scale(0.759095,1.000000),translate(-0.317475,0.154812)",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.02370692%",
    y1: "82.9643562%",
    x2: "62.7908145%",
    y2: "30.7871799%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227716",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20b228",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "40.3522188%",
    cy: "82.1568842%",
    fx: "40.3522188%",
    fy: "82.1568842%",
    r: "78.461849%",
    gradientTransform: "translate(0.403522,0.821569),scale(0.654597,1.000000),rotate(-38.249016),translate(-0.403522,-0.821569)",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: "99.8%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2c2c2c",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.08 77.537l-38.974-1.113c-4.718-.202-10.16-5.824-10.092-10.517l.186-39.23c.068-4.71 5.407-9.165 10.1-9.116l38.45 1.418c4.684.068 10.06 4.407 9.992 9.1v40.058c0 5.113-4.06 9.402-9.673 9.402z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.367 62.833l6.2-1.5c.252.743 1.247 2.583 2.122 3.325s3.335 1.147 4.97.995 2.444-1.588 2.528-2.65c.068-1.047-.438-1.8-1.4-2.278s-2.038-.777-3.555-1.23c-1.517-.438-4.23-1.047-6.37-2.5-2.122-1.45-2.646-4.777-2.662-5.958s.27-2.92 1.027-4.186c.76-1.283 3.236-4.052 8.156-4.052s6.977 1.57 8.103 2.48 2.932 4.17 2.932 4.17L70.76 51.49c-.962-2.82-2.746-3.782-5.2-3.782s-3.016 1.554-3.016 2.48.54 2.042 2.864 2.65 6.167 1.57 8.004 2.75 3.52 3.63 3.52 6.483-1.11 4.407-2.072 5.47c-.962 1.047-3.285 3.478-8.24 3.478-4.766-.016-9.584-2.126-12.264-8.186zm43.084-.71s.927-11.546-9.84-11.546c-9.738 0-9.37 10-9.37 10.7 0 2.887 1.685 10.297 9.91 10.297s9.3-6.92 9.3-6.92l-5.612-.66c-.27.71-.825 3.257-3.453 3.257s-3.47-2.126-3.673-2.82-.152-2.312-.152-2.312l12.9.003zM84.51 58.78s-.152-4.373 3.623-4.373 3.52 4.373 3.52 4.373H84.51z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.135 30.744v19.428s2.292 10.262 9.468 10.465l36.43 1.18c2.426-.118 8.813-3.46 8.813-9.942V32.652c0-3.73-2.156-11-10.38-11.378s-31.324-.98-33.933-.98c-4.265-.018-10.398 1.62-10.398 10.45z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c0000",
    strokeWidth: 0.5,
    fill: "url(#C)",
    d: "M78.04 33.68l11.305 14.265 26.64-22.215-3.673-7.394-22.123 18.87-7.886-8.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M78.664 33.53L89.7 43.555 107.78 29.3l-2.088-4.795L90.14 37.762l-7.836-8.845z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelenium);
export default __webpack_public_path__ + "static/media/Selenium.6eb82ae0eedceb7709582e1f5ca1bfd6.svg";
export { ForwardRef as ReactComponent };